import { Box, Checkbox } from "@mui/material";
import type { MouseEvent } from "react";
import { type JobEventForInvoice, useJobEventsBoard } from "../context";
import { SASCheckboxStyles } from "../../../../../ui/styles/SASStyles";

export const JobEventMultilpeInvoiceCheck = ({ jobEvent, disabled }: { jobEvent: JobEventForInvoice; disabled?: boolean }) => {
  const { selectJobEvent, unSelectJobEvent, isJobEventSelected } = useJobEventsBoard();
  const stopTrigger = (e: MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <Box
      onClick={stopTrigger}
      onMouseDown={stopTrigger}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        alignSelf: "stretch",
        pl: 0.25,
      }}
    >
      <Checkbox
        sx={{ ...SASCheckboxStyles, p: 0 }}
        checked={isJobEventSelected(jobEvent.uid)}
        disabled={disabled}
        onClick={stopTrigger}
        onMouseDown={stopTrigger}
        onChange={() => {
          if (isJobEventSelected(jobEvent.uid)) {
            unSelectJobEvent(jobEvent.uid);
          } else {
            selectJobEvent(jobEvent);
          }
        }}
      />
    </Box>
  );
};
